import {useState, useEffect} from 'react'
import { useAppContext } from './../Context';

//import tags
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';

// import recources
import Facebook from '../../assets/image/facebook.png'
import Youtube from '../../assets/image/youtube.png'
import Location from '../../assets/image/location.png'
import Envelope from '../../assets/image/envelope.png'
import Phone from '../../assets/image/phone.png'

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

function getDate() {
    const today = new Date();
    const year = today.getFullYear();
    return `${year}`;
}

  
function Footer({locale}) {

    const [currentDate, setCurrentDate] = useState(getDate());
    const [showScrollTop, setShowScrollTop] = useState(false);

    const { globalContact } = useAppContext();

    //get locale
    const { t } = useTranslation();

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            setShowScrollTop(scrollTop > 300);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const smoothScrollToTop = () => {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const startY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

        if (startY <= 0) return;

        if (prefersReducedMotion) {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            return;
        }

        const duration = Math.min(1400, Math.max(700, startY * 0.35));
        const easeInOutCubic = (t) => {
            return t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        };

        const startTime = performance.now();

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutCubic(progress);
            const nextY = Math.round(startY * (1 - eased));

            window.scrollTo(0, nextY);
            document.documentElement.scrollTop = nextY;
            document.body.scrollTop = nextY;

            if (progress < 1) {
                window.requestAnimationFrame(animate);
            }
        };

        window.requestAnimationFrame(animate);
    };

    const handleScrollTopButtonClick = () => {
        smoothScrollToTop();
    };

    const scrollToTopOnInternalFooterLink = (event) => {
        const anchor = event.target.closest('a');
        if (!anchor) return;

        const href = anchor.getAttribute('href') || '';
        if (href.startsWith('/')) {
            window.requestAnimationFrame(() => {
                smoothScrollToTop();
            });
        }
    };


    return (
        <>
        <footer className="footer" onClickCapture={scrollToTopOnInternalFooterLink}>
            <Container>
                <Row>
                    <Col xxl={3}>
                        <div className="footer_menu">
                            <h4>{t('statements')}</h4>
                            <ul>
                                <li><Link to={`/${locale}/property?property_status=underconstruction&property_type=apartment&city=tbilisi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('under_construction_apartments_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_status=underconstruction&property_type=apartment&city=batumi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('under_construction_apartments_batumi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_status=new&property_type=apartment&city=tbilisi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('new_apartments_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=land&page=1`}><FontAwesomeIcon icon={faCaretRight} /> ბინები დღიურად</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=land&page=1`}><FontAwesomeIcon icon={faCaretRight} /> ქირავდება ბინები</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=land&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('land_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=business&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('business_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=rent&property_type=office&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('offices_for_rent')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=penthouse&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('penthouse_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=businesscenter&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('business_center_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=farm&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('farm_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=house&city=tbilisi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('private_house_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property`}><FontAwesomeIcon icon={faCaretRight} /> {t('private_house_near_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&transaction_type=rent&city=tbilisi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_for_rent_tbilisi')}</Link></li>
                                
                            </ul>
                        </div>
                    </Col>
                    <Col xxl={3}>
                        <div className="footer_menu">
                            <h4>&nbsp;</h4>
                            <ul>
                                <li><Link to={`/${locale}/property?property_type=apartment&transaction_type=rent&city=tbilisi&rooms_from=1&rooms_to=1&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('one_room_apartments_for_rent_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&transaction_type=rent&city=tbilisi&rooms_from=2&rooms_to=2&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('two_room_apartments_for_rent_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&transaction_type=rent&city=tbilisi&rooms_from=3&rooms_to=3&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('three_room_apartments_for_rent_tbilisi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&region=achara&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_achara')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=house&transaction_type=rent&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('cottage_for_rent')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=bakuriani&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_bakuriani')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=gudauri&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_gudauri')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=comercial&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('commercial_property_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=land&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('land_plot_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=sale&property_type=house&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('cottage_for_sale')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=rent&property_type=comercial&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('commercial_property_for_rent')}</Link></li>
                                <li><Link to={`/${locale}/property?transaction_type=rent&property_type=house&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('cottage_for_rent_rent')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=saburtalo&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_saburtalo')}</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col xxl={3}>
                        <div className="footer_menu">
                            <h4>&nbsp;</h4>
                            <ul>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=saburtalo&ubani=dididigomi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_didi_dighomi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=gldani&page=1`}> <FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_gldani')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=varketili&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_varketili')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=isani&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_isani')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=vake&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_vake')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=mtatsminda&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_mtatsminda')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=avlabari&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_avlabari')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=vera&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_vera')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=chughureti&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_chughureti')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=nadzaladevi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_nadzaladevi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=didube&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_didube')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=tbilisi&destrict=digomi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_digomi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=batumi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_batumi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=kutaisi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_kutaisi')}</Link></li>
                                <li><Link to={`/${locale}/property?property_type=apartment&city=rustavi&page=1`}><FontAwesomeIcon icon={faCaretRight} /> {t('apartments_in_rustavi')}</Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col xxl={3}>
                        <div className="footer_menu">
                            <h4>{t('contact_info_short')}</h4>
                            <ul className="footerContactIcons">
                                <li><Link to=''><Image src={Location} alt="Location" />{ typeof globalContact == 'object' ? globalContact?.translations[0].address : '' }</Link></li>
                                <li><Link to={ typeof globalContact == 'object' ? 'mailto:'+globalContact?.email : '' }><Image src={Envelope} alt="Envelope" />{ typeof globalContact == 'object' ? globalContact?.email : '' }</Link></li>
                                <li><Link to={ typeof globalContact == 'object' ? 'tel:'+globalContact?.phone : '' }><Image src={Phone} alt="Envelope" />{ typeof globalContact == 'object' ? globalContact?.phone : '' }</Link></li>
                                <li className="socialFtrBox">
                                    <div className="footerSocial">
                                        <div className="singleSocial">
                                            <Link to={globalContact?.facebook} target='_blank'>
                                                <FontAwesomeIcon icon={faFacebook} />
                                            </Link>
                                        </div>
                                        <div className="singleSocial">
                                            <Link to={globalContact?.instagram} target='_blank'>
                                                <FontAwesomeIcon icon={faInstagram} />
                                            </Link>
                                        </div>
                                        <div className="singleSocial">
                                            <Link to={globalContact?.tiktok} target='_blank'>
                                                <FontAwesomeIcon icon={faTiktok} />
                                            </Link>
                                        </div>
                                        <div className="singleSocial">
                                            <Link to={globalContact?.youtube} target='_blank'>
                                                <FontAwesomeIcon icon={faYoutube} />
                                            </Link>
                                        </div>
                                    </div>    
                                </li>
                            </ul>
                        </div>
                    </Col>
                </Row>

            </Container>

            <div className="footerBottom">
                <Container>
                    <Row className="w-100">
                        <Col xxl={6} className="p-0">
                            <div className="footerBottomLeft">
                                <p>&copy; RELUX.GE {currentDate}. {t('all_rights')}.</p>
                            </div>
                        </Col>
                        <Col xxl={6} className="p-0">
                            <div className="footerBottomRight">
                                <Link to={`/${locale}/terms`}>{t('terms_conditions')}</Link>
                                <Link to={`/${locale}/privacy`}>{t('confidential')}</Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
                
            </div>

        </footer>

        <button
            type="button"
            className={`scrollTopButton ${showScrollTop ? 'active' : ''}`}
            onClick={handleScrollTopButtonClick}
            aria-label="Scroll to top"
        >
            ↑
        </button>
        </>

        
    )
    
}

export default Footer;